import { H4 } from '@xo-union/tk-ui-typography';
import React, { type FunctionComponent } from 'react';
import Styles from '../../../styles.scss';
import type { ArticleDetails } from '../../../types';

export interface Props {
	article: ArticleDetails;
	categoryLink: string;
	categoryName: string;
	trackClickThroughToContent: () => void;
}

export const ArticleTitle: FunctionComponent<Props> = (props: Props) => {
	const { article, categoryLink, categoryName, trackClickThroughToContent } =
		props;

	return (
		<div className={Styles.articleInfo}>
			<a href={categoryLink} className={Styles.articleCategory}>
				{categoryName.toUpperCase()}
			</a>

			<a href={article.href} onClick={trackClickThroughToContent}>
				<H4 className={Styles.articleTitle}>{article.title}</H4>
			</a>
		</div>
	);
};
